import React from 'react';

const IconLogo = () => (
  <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Mughees' homepage</title>
    <g id="Logo" transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <g id="Logo" transform="translate(11.000000, 5.000000)">
          <path fill="#64FFDA" d="M0.360,28.784 L6.539,28.784 L8.218,8.977 L12.438,28.784 L16.852,28.784 L20.878,9.020 
          L22.622,28.784 L29.081,28.784 L25.808,0.042 L17.390,0.042 L16.120,6.501 C15.789,8.151 15.481,9.845 
          15.194,11.582 L14.483,16.039 C13.808,11.575 12.883,6.242 11.706,0.042 L3.460,0.042 L0.360,28.784 Z" 
          transform="rotate(0 0 0)translate(14, 25)" />
        </g>
        <polygon
          id="Shape"
          stroke="#64FFDA"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
